export function SubscriptIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M21.34 13.94a1 1 0 01-1.108-.3L17 9.762V13a1 1 0 01-2 0V7a1 1 0 011.768-.64L20 10.238V7a1 1 0 112 0v6a1 1 0 01-.66.94zM3 18a1 1 0 010-2h18a1 1 0 110 2H3z"
      ></path>
    </svg>
  );
}
